import { PropsWithChildren } from 'react';
import HeaderComponent from '../../routes/layout/components/header.component';
import { AppLogoComponent } from '../../routes/layout/components/logo/app-logo.component';
import MainContainerComponent from '../../routes/layout/components/main-container/main-container.component';

export const MessagePageComponent = ({ children }: PropsWithChildren) => {
  return (
    <>
      <HeaderComponent logo={<AppLogoComponent />} />
      <MainContainerComponent>
        <div className="container py-5">{children}</div>
      </MainContainerComponent>
    </>
  );
};
